/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function SubCustomerTableConfig($translate, $mdDialog, $document, $state, toast, types, utils, userService, subCustomerService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(/*params*/) {
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.subCustomer,

            tableTitle: $translate.instant('subCustomer.subCustomers'),

            columns: [
                { key: 'createdTime',
                  title: 'entity.createdTime'},
                { key: 'title',
                  title: 'subCustomer.title'},
                { key: 'country',
                  title: 'contact.country'},
                { key: 'city',
                  title: 'contact.city'},
                { key: 'devicesCount',
                  title: 'subCustomer.devices-count'}
            ],

            loadEntities: () => {return subCustomerService.getSubCustomers()},
            loadEntity: (entityId) => {return subCustomerService.getSubCustomer(entityId)},
            saveEntity: (entity) => {return subCustomerService.saveSubCustomer(entity)},
            deleteEntity: (entityId) => {return subCustomerService.deleteSubCustomer(entityId)},

            manageApplications: (event, entity) => {
                manageApplications(event, entity);
            },

            manageUsers: (event, entity) => {
                manageUsers(event, entity);
            },

            actionCellDescriptors: [
                {
                    name: 'subCustomer.manage-applications',
                    icon: 'apps',
                    isEnabled: () => {
                        return true;
                    },
                    onAction: ($event, entity) => {
                        manageApplications($event, entity);
                    }
                },
                {
                    name: 'subCustomer.manage-users',
                    icon: 'account_circle',
                    isEnabled: () => {
                        return true;
                    },
                    onAction: ($event, entity) => {
                        manageUsers($event, entity);
                    }
                }
            ],

            addEnabled: () => {
                return access == types.access.admin;
            },
            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('subCustomer.delete-sub-customer-title', {title: entity.title});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('subCustomer.delete-sub-customer-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('subCustomer.delete-sub-customers-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('subCustomer.delete-sub-customers-text');
            }

        };

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function manageUsers($event, subCustomer) {
        if ($event) {
            $event.stopPropagation();
        }
        $state.go('home.subCustomers.users', {subCustomerId: subCustomer.id.id});
    }

    function manageApplications($event, subCustomer) {
        if ($event) {
            $event.stopPropagation();
        }
        $state.go('home.subCustomers.applications', {subCustomerId: subCustomer.id.id});
    }

}



// WEBPACK FOOTER //
// ./src/app/subcustomer/subcustomer-table.config.js